<template>
  <div class="inline">
    <div v-if="payload.fileType === 'image'" class="inline">
      <img
        :src="link"
        alt="Image"
        @click="showImage(link)"
        class="media__image"
      />
    </div>
    <div v-else-if="payload.fileType === 'video'" class="inline">
      <video
        v-if="isValid"
        :key="videoLink"
        :poster="videoLink"
        width="200"
        height="150"
        class="media__video"
        controls
      >
        <source :src="videoLink" type="video/mp4" />
      </video>
    </div>
    <div v-else class="inline">
      <span class="message">
        <i class="fas fa-paperclip"></i>
        <a href="" v-on:click.stop.prevent="openWindow(link)">
          {{
            payload.message
              ? payload.message
              : payload.name
              ? payload.name
              : filename(link)
          }}
        </a>
      </span>
    </div>
    <b-modal class="preview__modal" :active.sync="isPreviewImage">
      <img class="preview__image" :src="link" alt="Image" />
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.media__image {
  width: 60%;
  padding: 0px !important;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
}
</style>

<script>
export default {
  name: 'PayloadMedia',
  props: {
    payload: Object
  },
  data() {
    return {
      link: 'loading',
      videoLink: '#t=0.1',
      isValid: false,
      isPreviewImage: false
    }
  },
  created() {
    if (this.payload.filePath) {
      this.link = `${process.env.VUE_APP_BASE_API}/${this.payload.filePath}`
      this.videoLink = `${process.env.VUE_APP_BASE_API}/${this.payload
        .filePath + this.videoLink}`
      this.isValid = true
    }
    // else {
    //   this.getLink(this.payload.filePath)
    // }
  },
  methods: {
    toggleImageModal() {
      this.isPreviewImage = !this.isPreviewImage
    },
    showImage() {
      this.isPreviewImage = true
    },
    filename(fullname) {
      return this.$parent.$parent.filename(fullname)
    },
    openWindow(url) {
      this.$parent.$parent.openWindow(url)
    }
    // async getLink(url) {
    //   const realUrl = await apiChat.getMediaUrl(url)
    //   this.link = realUrl.filePath
    //   this.isValid = realUrl.is_valid
    // }
  }
}
</script>
